import clsx from 'clsx';

import type { IAPPillProps, TPillTone } from './types';
import type { ReactNode } from 'react';

// No custom styles needed — all visuals come from panel.css .ap-badge classes

// Map APPill tones to panel.css .ap-badge--* modifiers
const toneClassMap: Record<TPillTone, string> = {
  success: 'ap-badge--success',
  warning: 'ap-badge--warning',
  error:   'ap-badge--danger',   // error → danger
  info:    'ap-badge--info',
  muted:   'ap-badge--neutral',  // muted → neutral
};

// Size: panel.css doesn't have badge size variants — size is handled by font-size tokens
const sizeClassMap = {
  small:  '',       // default badge size
  medium: '',       // same size (panel.css badge is uniform)
};

export const APPill = ({
  label,
  tone = 'info',
  size = 'small',
  icon,
  className,
  as: Component = 'span',
  'data-testid': testId,
  ...restProps
}: IAPPillProps) => {
  // panel.css: ap-badge__dot is a 6×6 filled circle bullet (no icon inside).
  // When the caller passes a ReactNode icon, render it directly;
  // when icon is boolean true (legacy), render the status dot.
  let leadElement: ReactNode = null;
  if (icon) {
    if (typeof icon === 'boolean') {
      leadElement = <span className="ap-badge__dot" aria-hidden="true" />;
    } else {
      leadElement = icon as ReactNode;
    }
  }

  return (
    <Component
      className={clsx('ap-badge', toneClassMap[tone], sizeClassMap[size], className)}
      data-testid={testId}
      {...restProps}
    >
      {leadElement}
      {label}
    </Component>
  );
};

APPill.displayName = 'APPill';

export type { IAPPillProps };
export default APPill;
